import { Tag } from "antd";

type DetailProps = { 
    value: string;
}; 

export const DetailTag = ({ value }: DetailProps) => { 
    return ( 
      <Tag className="table-detail-tag"> {value} </Tag> 
    ); };